namespace JupitersChoice {
    
    export class SkipBigWinWithSpaceCmd {

        @inject('BigWinModel') _bigWinModel: BigWinModel;
        @inject('LocalStorageManager') _localStorageManager: Sapphire.LocalStorageManager;

        execute(): void {
            if(this._localStorageManager.get('settings.spaceToSpin',false) && !Sapphire.Device.isMobile){
                if(this._bigWinModel.playing){
                    this._bigWinModel.dismiss();
                }
            }
        }
    }
}